module.exports = __webpack_public_path__ + "static/img/IMG_20150307_191429.a9b8018e.jpg";